import { useEffect, useState } from "react";
import Modal from "../../../components/ui/Modal";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import SelectCountries from "../../../components/ui/Selects/Countries";
import FieldError from "../../../components/ui/FieldError";
import RequiredField from "../../../components/ui/RequiredField";
import axiosConfig from "../../../services/Axios";
import { toast } from "react-toastify";
import { pickBy } from "lodash";

function AddressForm({
  partner,
  partnerAddressSelected,
  modalIsOpen,
  setIsOpen,
  cb = null,
}) {
  const form = useForm();
  const [country, setCountry] = useState();
  const { t } = useTranslation();

  const setCountryByGeoloc = async () => {
    await fetch(
      "https://api.geoapify.com/v1/ipinfo?apiKey=" +
        process.env.REACT_APP_GEOAPIFY_API_KEY,
      {
        method: "GET",
      }
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        setCountry(json.country.iso_code);
      });
  };

  useEffect(() => {
    setCountryByGeoloc();
  }, []);

  const onSubmitPartnerAddress = async (data) => {
    try {
      if (partnerAddressSelected) {
        data.partner = partner["@id"];

        await axiosConfig
          .patch(
            process.env.REACT_APP_API_URL + partnerAddressSelected["@id"],
            data,
            {
              headers: { "Content-Type": "application/merge-patch+json" },
            }
          )
          .then((response) => {
            if (response?.status === 200 && response?.data) {
              toast.success(t("global.changes_saved"), {
                theme: "colored",
                hideProgressBar: true,
              });

              let newPartnerAddresss = partner.partnerLogisticAddresses.map(
                (pc) =>
                  pc["@id"] === partnerAddressSelected["@id"]
                    ? response.data
                    : pc
              );
              partner.partnerLogisticAddresses = newPartnerAddresss;

              setIsOpen(false);
            }
          });
      } else {
        data.partner = partner["@id"];
        data.main = false;

        const sanitizedData = pickBy(
          data,
          (value) =>
            value !== null &&
            (value > 0 ||
              value.length > 0 ||
              (typeof value === "object" && !Array.isArray(value)))
        );

        await axiosConfig
          .post(
            process.env.REACT_APP_API_URL + "/api/partner_logistic_addresses",
            sanitizedData
          )
          .then((response) => {
            if (response?.status === 201 && response?.data) {
              toast.success(t("partnerLogisticAddress.created"), {
                theme: "colored",
                hideProgressBar: true,
              });

              let newPartnerAddresss = partner.partnerLogisticAddresses.concat(
                response.data
              );
              partner.partnerLogisticAddresses = newPartnerAddresss;
            }

            setIsOpen(false);

            if (cb instanceof Function) {
              cb(response.data);
            }
          });
      }

    } catch (e) {
      if (e.response?.status !== 200 && e.response?.data?.violations) {
        e.response.data.violations.map((v) => {
          form.setError(v.propertyPath, {
            type: "manual",
            message: v.message,
          });
        });
      }
    }
  };

  useEffect(() => {
    form.reset();
  }, [modalIsOpen]);

  return (
    <div>
      <Modal
        showModal={modalIsOpen}
        setShowModal={setIsOpen}
        title={
          partnerAddressSelected
            ? t("partnerLogisticAddress.edit")
            : t("partnerLogisticAddress.create")
        }
        sendLabel={t("global.btn.save")}
        onSubmit={form.handleSubmit(onSubmitPartnerAddress)}
        zIndex="z-50"
      >
        <form onSubmit={form.handleSubmit(onSubmitPartnerAddress)}>
          <div className="grid grid-cols-12 gap-3">
            <div className="col-span-12">
              <label>
                {t("partnerLogisticAddress.address")}
                <RequiredField /> :
              </label>
              <input
                {...form.register("address")}
                name="address"
                type="text"
                className="w-full"
                defaultValue={partnerAddressSelected?.address}
                aria-invalid={form.formState?.errors?.address ? true : false}
              />
              <FieldError error={form.formState?.errors?.address} />
            </div>

            <div className="col-span-8">
              <label>{t("partnerLogisticAddress.address_complement")} :</label>
              <input
                {...form.register("addressComplement")}
                name="addressComplement"
                type="text"
                className="w-full"
                defaultValue={partnerAddressSelected?.addressComplement}
                aria-invalid={
                  form.formState?.errors?.addressComplement ? true : false
                }
              />
              <FieldError error={form.formState?.errors?.addressComplement} />
            </div>

            <div className="col-span-4">
              <label>
                {t("partnerLogisticAddress.zipcode")} <RequiredField /> :
              </label>
              <input
                {...form.register("zipcode")}
                name="zipcode"
                type="text"
                className="w-full"
                defaultValue={partnerAddressSelected?.zipcode}
                aria-invalid={form.formState?.errors?.zipcode ? true : false}
              />
              <FieldError error={form.formState?.errors?.zipcode} />
            </div>

            <div className="col-span-6">
              <label>
                {t("partnerLogisticAddress.city")} <RequiredField /> :
              </label>
              <input
                {...form.register("city")}
                name="city"
                type="text"
                className="w-full"
                defaultValue={partnerAddressSelected?.city}
                aria-invalid={form.formState?.errors?.city ? true : false}
              />
              <FieldError error={form.formState?.errors?.city} />
            </div>
            <div className="col-span-6">
              <label>
                {t("partnerLogisticAddress.country")} <RequiredField /> :
              </label>
              {country && (
                <>
                  <Controller
                    name="country"
                    control={form.control}
                    childRef={form.register}
                    defaultValue={
                      partnerAddressSelected?.country
                        ? partnerAddressSelected.country
                        : country
                    }
                    render={({ field: { onChange, value } }) => (
                      <SelectCountries onChange={onChange} value={value} />
                    )}
                  />
                  <FieldError error={form.formState?.errors?.country} />
                </>
              )}
            </div>
            <div className="col-span-12">
              <label>{t("partnerLogisticAddress.comment")} :</label>
              <textarea
                {...form.register("comment")}
                name="comment"
                className="rounded w-full"
                rows={3}
                defaultValue={partnerAddressSelected?.comment}
                aria-invalid={form.formState?.errors?.comment ? true : false}
              />
              <FieldError error={form.formState?.errors?.comment} />
            </div>
            <div className="col-span-12 flex items-center">
              <label>{t("partnerLogisticAddress.dock")} :</label>
              <input
                {...form.register("dock")}
                name="dock"
                type="checkbox"
                className="rounded ml-4 mt-1"
                defaultChecked={partnerAddressSelected?.dock}
                aria-invalid={form.formState?.errors?.dock ? true : false}
              />
              <FieldError error={form.formState?.errors?.dock} />
            </div>
          </div>
          <input type="submit" className="hidden" />
        </form>
      </Modal>
    </div>
  );
}

export default AddressForm;
